import styles from './wppBtn.module.scss';

export default function WppBtn({ url }) {
	function trackClick() {
		if (window.dataLayer) {
			window.dataLayer.push({ event: 'whatsapp_click', position: 'floating' });
		}
	}

	return (
		<a
			className={styles.wpp}
			href={url}
			target="_blank"
			rel="noreferrer"
			aria-label="Falar agora com a Multilentes pelo WhatsApp"
			onClick={trackClick}
		>
			<img src="/assets/wpp/wpp.png" alt="" />
			<span>Fale conosco</span>
		</a>
	);
}
